import React from "react";
import { api } from "../utils/convex-api";
import { Pressable, Text, View } from "react-native";
import { Avatar } from "../ui/avatar";
import { format } from "date-fns";
import { useRouter } from "expo-router";

type ParentChatListItemProps = {
  chat: (typeof api.parent.inbox.queries.getChats._returnType)[number];
};

function ParentChatListItem(props: ParentChatListItemProps) {
  const { chat } = props;
  const router = useRouter();

  const handlePress = () => {
    router.push(`/(app)/chat/${chat._id}`);
  };

  return (
    <Pressable className="px-5 py-4" onPress={handlePress}>
      <View className="flex-row items-center gap-6">
        <View>
          <Avatar size="base">
            <Avatar.Content
              source={
                chat.tutorImageUrl ? { uri: chat.tutorImageUrl } : undefined
              }
              label={chat.title}
              labelSize="base"
              size="base"
            />
          </Avatar>

          <Avatar className="size-8 absolute top-0 right-[-12]">
            <Avatar.Content
              source={
                chat.studentImageUrl ? { uri: chat.studentImageUrl } : undefined
              }
              label={chat.studentName}
              labelSize="sm"
              size="sm"
            />
          </Avatar>
        </View>
        <View className="flex-1">
          <View className="items-center flex-row justify-between">
            <Text className="font-geologica-medium font-medium text-base text-teachLoop-textPrimary leading-[1.5]" numberOfLines={1}>
              {chat.title}
            </Text>
            <Text className="font-geologica-medium font-medium text-base text-teachLoop-textPrimary leading-[1.5]" numberOfLines={1}>
              {chat.lastMessage?.createdAt
                ? format(chat.lastMessage?.createdAt, "HH:mm")
                : ""}
            </Text>
          </View>
          <Text className="font-geologica-regular font-normal text-sm text-teachLoop-textPrimary leading-[1.5]" numberOfLines={1}>
            {chat.subtitle}
          </Text>
          {chat.lastMessage?.content && (
            <View>
              <Text className="font-geologica-regular font-normal text-sm text-teachLoop-textSecondary leading-[1.5]" numberOfLines={1}>
                {chat.lastMessage?.content}
              </Text>
              {chat.hasUnreadMessages && (
                <View className="bg-teachLoop-accentPrimary size-6 rounded-full absolute right-0 top-0 items-center">
                  <Text className="font-geologica-medium font-medium text-sm text-white leading-[1.5]">
                    {chat.unreadMessagesCount}
                  </Text>
                </View>
              )}
            </View>
          )}
        </View>
      </View>
    </Pressable>
  );
}

export default ParentChatListItem;
